import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-slate-900 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-126" data-mp="1j9740qqiilye">
      <div className="mx-auto max-w-3xl px-4" data-id="element-127" data-mp="1n9ir0a6ckyd1">
        <SectionHeading id="pricing-title" data-id="element-128" data-mp="1ncwph7bw4nf7">Choose Your <span className="text-amber-400" data-id="element-129" data-mp="1s8lv9sei70jy">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-amber-400 bg-slate-950 shadow-lg shadow-black/40" data-id="element-130" data-mp="1x8zuqm21h26d">
          <div className="border-b border-slate-800 px-6 py-4 sm:px-10" data-id="element-131" data-mp="226rw06okq0n8">
            <span className="inline-flex items-center gap-2 rounded-full bg-amber-400/10 px-3 py-1 text-xs font-semibold text-amber-300" data-id="element-132" data-mp="2v8lhnnmgkbg">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-133" data-mp="7ubs3cj92ylj" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-134" data-mp="1mhzirbv4kjbz">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-135" data-mp="1hq7xnguqn5t8">
              <div data-id="element-136" data-mp="1cqlmre2du1nl">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-137" data-mp="1cq3lg30v4x8t">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-300" data-id="element-138" data-mp="17td5dfp261ne">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-139" data-mp="20hhd06r6wosq">
                <span className="text-sm text-slate-400" data-id="element-140" data-mp="1vhcsm5n5v9x8">
                  Regular price: <span className="line-through decoration-2" data-id="element-141" data-mp="1vfjmqskdgtqa">{priceBefore}</span>
                </span>
                <p className="mt-2 text-sm font-medium text-slate-300" data-id="element-142" data-mp="1rhu8vd72t4vz">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-bold leading-none tracking-tight text-amber-400 sm:text-6xl" data-id="element-143" data-mp="k3r66s8ormfe">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" checkout arrow className="mt-9 w-full" data-id="element-144" data-mp="hit5v7inhu7i">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-slate-300" data-id="element-145" data-mp="7kddl17w0ewf">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="3uwo70bq23d25">
                  <CheckCircle2Icon className="h-4 w-4 text-orange-400" aria-hidden="true" data-id="element-147" data-mp="3uul5ovjgdxi4" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}